import serializeQueryParameters from "./serializeQueryParameters";

const appendQueryParameters = (url, parameters) =>
  `${url}?${serializeQueryParameters(parameters)}`;

export default appendQueryParameters;
